import script from "./ActivityGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityGallery.vue?vue&type=script&setup=true&lang=js"

import "./ActivityGallery.vue?vue&type=style&index=0&id=befc66b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-befc66b6"]])

export default __exports__